import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import styled from "styled-components";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import DialogContentText from "@material-ui/core/DialogContentText";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import MenuItem from "@material-ui/core/MenuItem";
import { Label } from "react-bootstrap";
import ChangePassword from "../../changepassword";
import { makeStyles } from "@material-ui/core/styles";
// import { styled } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";
import moment from "moment";
import { YoutubePlayer } from "reactjs-media";
import ReactPlayer from "react-player";
import { reportedUsersService } from "../../../services/index";
import Utils from "../../../utility";
import PasswordDrawer from "../../home/Component/passwordDrawer";
import Popup from "./dialogDeletePopup";
import BlockPopUp from "./dialogBlockContent"
import toast, { Toaster } from "react-hot-toast";
import CommonToasts from "../../../common/components/commonToast";

const styles = (theme) => ({
  root: {
    // height:'auto',
    margin: 0,
    padding: theme.spacing(2),
    color: "#1f1f1f",
  },
  closeButton: {
    height: "15px",
    width: "15px",
    position: "absolute",
    right: "30px",
    top: "20px",
    color: "white",
    backgroundColor: "#FF0027",
    "&:hover, &.Mui-focusVisible": {
      color: "none",
      backgroundColor: "#FF0027",
    },
  },
  responsivedialog: {
    width: "1000px",
    height: "459px",
  },
});
const useStyles = makeStyles((theme) => ({
  Change: {
    color: "#001441",
  },
  paper: {
    "@media (min-width:1025px) and (max-width:3000px)": {
      width: "1000px !important",
      height: "490px",
      maxWidth: "1000px",
      borderRadius: "8px",
      maxHeight: "490px",
      overflow: "hidden !important",
    },
    "@media (min-width:768px) and (max-width:1024px)": {
      // top: "55px",
      overflow: "hidden !important",
      width: "100% !important",
    height: "100% !important",
    margin: 0,
    maxWidth: "100% !important",
    maxHeight: "none !important",
    borderRadius: "0",
    },
  },
}));

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography style={{ fontWeight: 700 }} variant="h6">
        {children}
      </Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon style={{ width: "18px", height: "18px" }} />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});
const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
  iframe: {
    borderRadius: "30px",
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
    "@media (min-width:768px) and (max-width:1024px)": {
      justifyContent: "space-evenly",
      margin: "auto 0 61px 0",
    },
  },
}))(MuiDialogActions);

const WebView = styled.div`
  @media (min-width: 0px) and (max-width: 767px) {
    display: none;
  }
  @media (min-width: 767px) and (max-width: 1024px) {
    display: none;
  }
  @media (min-width: 1024px) {
    display: visible;
  }
`;

const TabView = styled.div`
  @media (min-width: 0px) and (max-width: 767px) {
    display: none;
  }
  @media (min-width: 767px) and (max-width: 1024px) {
    display: visible;
  }
  @media (min-width: 1025px) {
    display: none;
  }
`;

export default function CustomizedDialogs(props) {
  const classes = useStyles();
  const [isPopUpOpen, setIsPopupOpen] = React.useState(false);
  const [isBlockPopUpOpen, setIsBlockPopupOpen] = React.useState(false);

  const [open, setOpen] = React.useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [isplaying, setIsplaying] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const opts = {
    borderRadius: "30px",
  };
  const deleteReport = async () => {
    if (props.review._id != "undefined") {
      const reqObj = {
        reportId: props.review._id,
      };

      const [err, res] = await Utils.parseResponse(
        reportedUsersService.deletereportedUsers(reqObj)
      );
      props.getreportedUsersList(res);
    }
  };

  const blockReport = async () => {
    const reqObj = {
      userID: props?.review?.contentOwner?.userID,
    };
    const [err, res] = await Utils.parseResponse(
      reportedUsersService.blockUser(reqObj)
    );
    props.getreportedUsersList(res);
    CommonToasts.successfullySent("Block User Successfull!!");
  };
  const blockContentNft = async () => {
    const reqObj = {
      contentId:props.review.contentId._id,
    };
    const [err, res] = await Utils.parseResponse(
      reportedUsersService.blockContent(reqObj)
    );
    props.getreportedUsersList(res);
    setIsBlockPopupOpen(!isBlockPopUpOpen)
    CommonToasts.successfullySent("Block Content Successfull!!");
  };

  const togglePopup = () => {
    setIsPopupOpen(!isPopUpOpen);
  };
  const toggleBlockPopup = () => {
    handleClose();
    setIsBlockPopupOpen(!isBlockPopUpOpen);
  };

  
  return (
    <div>
      <div>
          <Toaster />
        </div>
      <p
        onClick={handleClickOpen}
        className="fc-5386f8 font-sans cursor-pointer"
      >
        Review Content
      </p>
<div>
      <Dialog
        fullScreen={fullScreen}
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        classes={{ paper: classes.paper }}
      >
        <TabView>
          <div
            style={{
              height: "61px",
              boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
            }}
          >
            <PasswordDrawer user={props?.user} />
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              margin: "2.75rem 0rem 1rem 0rem",
            }}
          >
            <div className="changeReviewTitle">Review Content</div>
            <div>
              <img
                className="cursorReviewPointer pr-18"
                onClick={handleClose}
                src="/images/redCross.svg"
              />
            </div>
          </div>
        </TabView>

        <WebView>
          <DialogTitle id="dialog-title" className="fw-700" onClose={handleClose}>
            Review Content
          </DialogTitle>
        </WebView>

        <Grid container spacing={2} className="tab-view">
          <Grid item xs={4}>
            <DialogContent
              className="w-305 h-366 w-312 h-343 overflow"
              style={{ borderRadius: "30px" }}
              id="iframe"
            >
              <ReactPlayer
                url={
                  props?.review?.contentId?.cdnUrl ||
                  "https://d3givd2fx5ga4z.cloudfront.net/auth0|61c9b9f0f3fb95006a76c73e/files/mux_video_2021_11_29_19_27_29.mp4"
                }
                width={280}
                height={320}
                playing={isplaying}
                controls
                playIcon={""}
                // light="/images/reviewcontent.png"
                volume={1}
              />
            </DialogContent>
          </Grid>
          <Grid item xs={8} className="grid-tab">
            <p className="video-title">
              Video Title :{" "}
              <span className="video-span">{props?.review?.contentId?.title}</span>
            </p>
            <p className="video-description">
              Description :{" "}
              <span className="description-span">
                {props?.review?.contentId?.description ||
                  "Lorem ipsum dolor sit amet, consectetur adipisci elit, sed eiusmod tempor incidunt ut labore et dolore magna aliqua. Ut enim  nisi ut aliquid ex ea commodi consequaturr. "}
              </span>
            </p>
            <p className="video-description review-none">
              User Name :{" "}
              <span className="user-span">
                {props?.review?.contentOwner?.firstName}
              </span>
            </p>
            <p className="video-title review-none">
              Wallet ID :{" "}
              <span className="video-span">
                {props?.review?.walletId || "-"}
              </span>
            </p>
            <p className="video-title review-none">
              Last Reported On :{" "}
              <span className="video-span">
                {moment(props?.review?.modifiedOn).format("DD-MM-YYYY")}
              </span>
            </p>
            <p className="video-title review-none">
              Report Category :{" "}
              <span className="video-span">
                {props?.review?.reportedCategory}
              </span>
            </p>
            <p className="video-title review-none">
              No of Report :{" "}
              <span className="video-span">
                {props?.review?.reportedBy?.length}
              </span>
            </p>
            <br />
            <br />
            <Grid
              container
              spacing={{ xs: 2, md: 3 }}
              columns={{ xs: 4, sm: 8, md: 12 }}
              className="review-grid"
            >
              <Grid item xs={2} sm={4} md={4}>
                <p className="video-description">
                  User Name :{" "}
                  <span className="user-span">
                    {props?.review?.contentOwner?.firstName}
                  </span>
                </p>
              </Grid>
              <Grid item xs={2} sm={4} md={4}>
                <p className="video-title">
                  Last Reported On :{" "}
                  <span className="video-span">
                    {moment(props?.review?.modifiedOn).format("DD-MM-YYYY")}
                  </span>
                </p>
              </Grid>
              <Grid item xs={2} sm={4} md={4}>
                <p style={{ paddingLeft: "43px" }} className="video-title">
                No of Report :{" "}
                  <span className="video-span">
                    {props?.review?.reportedBy?.length}
                  </span>
                </p>
              </Grid>
              <Grid item xs={2} sm={4} md={4}>
                <p className="wallet-id">
                  Wallet ID :{" "}
                  <span className="video-span">{props?.review?.walletId}</span>
                </p>
              </Grid>
              <Grid item xs={2} sm={4} md={4}>
                <p className="video-title">
                  Report Category :{" "}
                  <span className="video-span">
                    {props?.review?.reportedCategory}
                  </span>
                </p>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <DialogActions className="mainReviewDialogAction">
          <Button
            variant="contained"
            className="h-51 reviewDialogAllowButton"
            color="primary"
            // onClick={() => {
            //   handleClose();
            //   deleteReport();
            // }}
            onClick={togglePopup}
          >
            Allow Content
          </Button>

          {isPopUpOpen && (
            <Popup
              handlePopUpClose={togglePopup}
              close={handleClose}
              delete={deleteReport}
            />
          )}

          <Button
            onClick={() => {
              handleClose();
              blockReport();
            }}
            className="bg-eee fc-1f1f1f h-51 reviewDialogBlockButton"
            variant="contained"
            autoFocus
          >
            Block User
          </Button>

          <Button
            onClick={toggleBlockPopup}
            className="fc-white h-51 reviewDialogRemoveButton"
            variant="contained"
            autoFocus
          >
            Remove Content
          </Button>
         
        </DialogActions>
      </Dialog>
      </div>
      {isBlockPopUpOpen && (
            <BlockPopUp
              handleBlockPopUpClose={toggleBlockPopup}
              closeBlock={handleClose}
              block={blockContentNft}
              reportUser={props.getreportedUsersList}
            />
          )}
    </div>
  );
}
